module.exports = __webpack_public_path__ + "static/media/carousel-arrow-large-left.302a2246.svg";